import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

import { HOST_URL } from '@shared/tokens/host-url';
@Injectable({providedIn: 'root'})
export class IconsLoader {

  constructor(private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(HOST_URL) private _hostUrl: string) {}

  public load(setName: 'core'|'edit'|'files'|'halls'|'news'|'sectors'|'social'|'stand'|'user'|'events'|'newsletter'|'ticks'|'services'|'tour'): void {
    const baseIconsUrl = `${this._hostUrl}/assets/icons/sprites/symbols/`;
    this.iconRegistry.addSvgIconSetInNamespace(setName,
      this.sanitizer.bypassSecurityTrustResourceUrl(baseIconsUrl + `${setName}.symbols.svg`));
  }
}
